import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';

import { Link } from '@mui/material';
import { AppCardSection, AppDescriptionList } from '@shared';
import { buildDescriptionListItems } from 'utils/index';

import snakeCase from 'lodash/snakeCase';

import CustomerTicketAttachments from './CustomerTicketAttachments';

const propTypes = {
  customerTicket: PropTypes.object.isRequired,
}

const defaultProps = {

}

const CustomerDataSection = (props) => {
  const { customerTicket } = props;

  const customerDataItems = buildDescriptionListItems([
    "customerKind",
    { name: "providerName", accessor: (value) => I18n.t(`enum.provider_name.${snakeCase(value)}`) },
    "customerName",
    "customerEmail",
    { name: "customerPhone", accessor: (value) => value, hideIfEmpty: true },
  ], customerTicket);

  const ticketDataItems = buildDescriptionListItems([
    { name: "providerOrderId", accessor: (_value, record) => <Link href={record.providerOrderUrl} target="_blank" rel="noopener">{ record.displayProviderOrderId }</Link> },
    "productTitle",
    "productSku",
    { name: "productOriginalTotal", accessor: (_value, record) => record.moneyProductOriginalTotal },
    { name: "ticketKind", accessor: (value) => I18n.t(`enum.ticket_kind.${snakeCase(value)}`) },
    { name: "reason", accessor: (value) => I18n.t(`enum.reason.${snakeCase(value)}`) },
    "description",
    { name: "resolutionPreference", accessor: (value) => I18n.t(`enum.resolution_preference.${snakeCase(value)}`) },
  ], customerTicket);

  const addressDataItems = buildDescriptionListItems([
    { name: "retrievalMethod", accessor: (value) => I18n.t(`enum.retrieval_method.${snakeCase(value)}`) },
    { name: "retrievalDate", accessor: (value) => value && I18n.l("time.formats.date_only", value) },
    "address",
    { name: "province", accessor: (value) => value, hideIfEmpty: true },
    { name: "canton", accessor: (value) => value, hideIfEmpty: true },
    { name: "district", accessor: (value) => value, hideIfEmpty: true },
    { name: "zip", accessor: (value) => value, hideIfEmpty: true },
    { name: "retrievalNotes", accessor: (value) => value, hideIfEmpty: true },
  ], customerTicket);

  return (
    <>
      <AppCardSection title="Cliente">
        <AppDescriptionList
          items={customerDataItems}
        />
      </AppCardSection>
      
      <AppCardSection title="Producto y motivo">
        <AppDescriptionList
          items={ticketDataItems}
        />
      </AppCardSection>
      
      <AppCardSection title="Retiro">
        <AppDescriptionList
          items={addressDataItems}
        />
      </AppCardSection>

      { customerTicket.media.length > 0 &&
        <AppCardSection title="Adjuntos">
          <CustomerTicketAttachments
            attachments={customerTicket.media}
          />
        </AppCardSection>
      }
    </>
  )
};

CustomerDataSection.propTypes = propTypes;
CustomerDataSection.defaultProps = defaultProps;

export default CustomerDataSection;